import React from 'react';
import { Row, Col, Form } from 'antd';

import { Card } from '../../Card';
import { useCreateStep } from '../hooks';
import { Description } from './Description';
import { useApplicationContext } from '@/context/Application';
import { useCustomReportManagerStepContext } from '../context';
import { CustomButton, CustomPlusCircleFilled } from './styles';

const { useFormInstance, useWatch } = Form;

export function CreateStep(): JSX.Element {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();
	const { addStepToStepList } = useCustomReportManagerStepContext();
	const description = useWatch(['step', 'description'], form);

	const { isLoading, mutateAsync: createStep } = useCreateStep();

	async function handleOnClick(): Promise<void> {
		if (!description) {
			return;
		}

		const created = await createStep({
			description,
			company_id: company?.id,
			organization_id: organization?.id,
		});

		if (created?.id && created?.description) {
			form.setFieldValue(['step', 'description'], undefined);
			addStepToStepList({
				id: created.id,
				description: created.description,
			});
		}
	}

	return (
		<Card title="Create section">
			<Row justify="space-between" align="middle" gutter={[10, 0]}>
				<Col span={22}>
					<Description isLoading={isLoading} />
				</Col>
				<Col span={2} style={{ textAlign: 'end' }}>
					<CustomButton type="submit" onClick={handleOnClick} disabled={!description || isLoading}>
						<CustomPlusCircleFilled inactive={!description || isLoading} />
					</CustomButton>
				</Col>
			</Row>
		</Card>
	);
}
